import { createClient } from '@supabase/supabase-js';

// Configuration Supabase via variables d'environnement
// Pour la branche staging, utilisez .env.local avec les credentials de la branche staging
// Pour la production, utilisez les variables d'environnement du déploiement
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase environment variables. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);